<template>
  <vs-row vs-justify="center">
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="12"
      vs-xs="12"
      vs-md="12"
      vs-sm="12"
    >
      <vs-card>
        <h3 class="card-title d-flex">
          List of Users
          <vs-button
            class="ml-auto"
            type="filled"
            icon="add_circle"
            size="small"
            @click="addingNewItem"
          >Add New User</vs-button>
        </h3>

        <p class="card-subtitle">List of all users details.</p>
        <vs-row class="d-flex align-items-center">
          <vs-col vs-lg="2" vs-xs="12" class="d-flex drop-width">
            <vs-select
              :color="colorx"
              label="Language Filter"
              @change="fileter($event, 'language')"
              v-model="search.language"
            >
              <vs-select-item value text="All Languages" />
              <vs-select-item
                :key="index"
                :value="item.culture"
                :text="item.culture"
                v-for="(item, index) in languages"
              />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="2" vs-xs="12" class="d-flex drop-width">
            <vs-select
              label="is Verified"
              @change="fileter($event, 'isVerified')"
              v-model="search.isVerified"
            >
              <vs-select-item value text="is Verified" />
              <vs-select-item value="true" text="Yes" />
              <vs-select-item value="false" text="No" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="2" vs-xs="12" class="d-flex drop-width">
            <vs-select
              :color="colorx"
              label="is Banned"
              @change="fileter($event, 'isBanned')"
              v-model="search.isBanned"
            >
              <vs-select-item value text="is Banned" />
              <vs-select-item value="true" text="Yes" />
              <vs-select-item value="false" text="No" />
              <vs-select-item value="tobe" text="To Be" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12" class="d-flex drop-width">
            <vs-select
              :color="colorx"
              label="Search On"
              @change="fileter($event, 'searchKey', false)"
              v-model="search.searchKey"
            >
              <vs-select-item value text="Search On" />
              <vs-select-item value="userEmail" text="Email" />
              <vs-select-item value="userName" text="Username" />
              <vs-select-item value="androidVersion" text="Android version" />
              <vs-select-item value="iOsVersion" text="IOS version" />
              <vs-select-item value="userMob" text="Mobile Number" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12" class="d-flex pt-4">
            <vs-input
              icon-after="true"
              label-placeholder="Search by selected parameter"
              icon="search"
              v-model="searchValue"
            />
          </vs-col>
          <vs-col vs-lg="2" class="d-flex pb-1">
            <vs-button
              color="primary"
              type="filled"
              class="searchBtn mr5"
              @click="fetchAllUsers()"
              icon="search"
            >Search</vs-button>
            <vs-button
              color="warning"
              type="filled"
              class="searchBtn"
              icon="cached"
              @click="resetData()"
            >Reset</vs-button>
          </vs-col>
        </vs-row>
        <br />
        <table class="table" scope="col">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Image</th>
            <th scope="col">Name</th>
            <th scope="col">Username</th>
            <th scope="col">Email</th>
            <th scope="col">Mobile Number</th>
            <th scope="col">Language</th>
            <th scope="col"></th>
          </tr>
          <tr v-for="(item, index) in all" :key="item.name">
            <td scope="col">{{ (currentPage - 1) * pageSize + index + 1 }}</td>
            <td scope="col">
              <img
                v-if="item.imageURL == '' || item.imageURL == null"
                src="../../../assets/images/No-image.png"
                height="50px"
                width="75px"
              />
              <img v-else :src="item.imageURL" height="50px" width="75px" />
            </td>
            <th scope="col">{{ item.firstName }} {{ item.lastName }}</th>
            <th scope="col">{{ item.userName }}</th>
            <td scope="col">{{ item.userEmail }}</td>
            <td scope="col">{{ item.userMob }}</td>
            <td scope="col">{{ item.language }}</td>
            <td scope="col">
              <vs-button class="mr15" size="small" color="warning" @click="editingItem(item)">Edit</vs-button>
              <vs-button
                class="mr15"
                size="small"
                color="danger"
                @click="
                  deleteUserPopup = true;
                  itemToDelete = item;
                "
              >Delete</vs-button>
              <vs-button
                class="top"
                size="small"
                color="primary"
                @click="
                  viewUserPopup = true;
                  itemToView = item;
                  fetchAllEvents();
                  invitedUsers();
                  fetchHinduCalendar(item.language)
                "
              >Profile</vs-button>
              <vs-button
                class="top"
                size="small"
                color="danger"
                v-if="item.strike >= 5 && item.isBanned == false"
                @click="
                  banUserPopup = true;
                  usertoBan = item;
                "
              >Banned</vs-button>
              <!-- <vs-button
                class="mr15"
                size="small"
                color="primary"
                @click="
                  deleteUserPopup = true;
                  itemToDelete = item;
                "
                >Notify</vs-button
              >-->
            </td>
          </tr>
        </table>

        <!-- pagination -->
        <div class="pg-margin" v-if="all.length">
          <div class="pagination">
            <a class="cursor-pointer pag-arrow" @click="pageChange('previous')">&laquo;</a>
            <a class="pag-txt-arrow">{{ this.$data.pagination.current_page }} of {{ totalPages }}</a>
            <a class="cursor-pointer pag-arrow" @click="pageChange('next')">&raquo;</a>
          </div>
        </div>
        <!-- pagination -->
        <vs-popup
          :title="newEvent ? 'Add New Event' : 'Edit Event'"
          class="holamundo modalOpenCss"
          :active.sync="eventModal"
          @close="cloneEventModal()"
        >
          <vs-row>
            <vs-col vs-lg="6" vs-xs="6">
              <label>
                Category
                <sub class="sub-text">*</sub>
              </label>
              <vs-select :color="colorx" v-model="event.categoryId" icon="arrow_downward">
                <vs-select-item value text="Choose Category" disabled />
                <vs-select-item
                  :value="item._id"
                  :text="item.categoryName"
                  v-for="(item, index) in categories"
                  :key="index"
                />
              </vs-select>
              <br />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="text" label="Email" v-model="event.email" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>
                Title
                <sub class="sub-text">*</sub>
              </label>
              <vs-input type="text" v-model="event.title" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>
                Description
                <sub class="sub-text">*</sub>
              </label>
              <vs-textarea type="text" v-model="event.description" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>
                Address
                <sub class="sub-text">*</sub>
              </label>
              <vs-textarea type="text" v-model="event.address2" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb-4">
              <label>
                Location
                <sub class="sub-text">*</sub>
              </label>
              <vue-google-autocomplete
                id="map"
                placeholder="Start typing Address"
                v-on:placechanged="getAddressData"
                @keyup.stop.prevent="getAddressData"
                v-model="event.address"
              ></vue-google-autocomplete>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>
                City
                <sub class="sub-text">*</sub>
              </label>
              <vs-input type="text" v-model="event.city" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>
                Taluk Name
                <sub class="sub-text">*</sub>
              </label>
              <vs-input type="text" v-model="event.talukName" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>
                District Name
                <sub class="sub-text">*</sub>
              </label>
              <vs-input type="text" v-model="event.districtName" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>
                State
                <sub class="sub-text">*</sub>
              </label>
              <vs-input type="text" v-model="event.state" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">
                      Event Image
                      <sub class="sub-text">*</sub>
                    </label>
                    <div class="btn">
                      <vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File
                    </div>
                    <input type="file" ref="fileInput" @change="uploadImage($event)" />
                  </div>
                </vs-col>
                <vs-col v-if="event.imageURL">
                  <vs-button
                    color="danger"
                    type="flat"
                    icon="clear"
                    class="closeBtn"
                    @click="deleteImage()"
                  ></vs-button>
                  <img :src="event.imageURL" class="imgUp" height="100px" width="150px" />
                  <b v-if="fileName">File Name : {{ fileName }}</b>
                </vs-col>
              </div>
            </vs-col>

            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Attachment</label>
                    <div class="btn">
                      <vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload an Attachment File
                    </div>
                    <input type="file" ref="fileInput" @change="uploadImage($event, true)" />
                  </div>
                </vs-col>
                <vs-col v-if="event.attachments">
                  <div class="row">
                    <div class="mr-2" v-for="(url, index) in event.attachments" :key="index">
                      <vs-button
                        color="danger"
                        type="flat"
                        icon="clear"
                        class="closeBtn"
                        @click="deleteattachmentImage(index)"
                      ></vs-button>
                      <img
                        :src="url.fileurl"
                        class="imgUp"
                        height="100px"
                        width="150px"
                        v-if="['image/jpeg', 'image/png', 'image/jpg'].includes(url.filetype)"
                      />
                      <vs-icon
                        icon="assignment"
                        @click="openDoc(url.fileurl)"
                        v-if="url.filetype === 'application/pdf'"
                        class="icon-medium pointer"
                      ></vs-icon>
                      <audio controls v-if="url.filetype === 'audio/mpeg'">
                        <source :src="url.fileurl" type="audio/mpeg" />Your browser does not support the audio element.
                      </audio>
                    </div>
                  </div>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="number" label="User Limit" v-model="event.userLimit" :min="1"/>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mt-4 p-bottom">
              <vs-checkbox v-model="event.isRecurring">Is Recurring</vs-checkbox>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mt-4 p-bottom" v-if="event.isRecurring">
              <vs-row>
                <vs-col vs-lg="6" vs-xs="12">
                  <label>Recurring Calendar Type</label>
                  <select v-model="event.calendarType" class="custom-select">
                    <option value disabled>Choose Calendar Type</option>
                    <option value="hindu">Hindu Calendar</option>
                    <option value="gregorian">Gregorian Calendar</option>
                  </select>
                </vs-col>

                <vs-col vs-lg="6" vs-xs="12" v-if="event.calendarType === 'hindu' || event.calendarType === 'gregorian'">
                  <label>Recurring Interval</label>
                  <select v-model="event.recurringInterval" class="custom-select">
                    <option value disabled>Choose Interval</option>
                    <option value="monthly">Monthly</option>
                    <option value="yearly">Yearly</option>
                  </select>
                </vs-col>
              </vs-row>

              <div v-if="event.calendarType === 'gregorian'">
                <div v-if="event.recurringInterval==='monthly'">

                <vs-row>
                  <vs-col vs-lg="6" vs-xs="6">
                    <label class="label">Day</label>
                    <select v-model="event.day" class="custom-select">
                      <option value disabled>Choose Day</option>
                      <option v-for="day in days" :key="day" :value="day">{{ day }}</option>
                    </select>
                  </vs-col>
                </vs-row>
                </div>
              </div>
              <div v-if="event.calendarType === 'gregorian'">
                <div v-if="event.recurringInterval==='yearly'">

                <vs-row>
                  <vs-col vs-lg="6" vs-xs="6">
                    <label class="label">Month</label>
                    <select v-model="event.month" class="custom-select">
                      <option value disabled>Choose Month</option>
                      <option
                        v-for="(month, index) in gregorianMonths"
                        :key="index"
                        :value="month"
                      >{{ month }}</option>
                    </select>
                  </vs-col>
                  <vs-col vs-lg="6" vs-xs="6">
                    <label class="label">Day</label>
                    <select v-model="event.day" class="custom-select">
                      <option value disabled>Choose Day</option>
                      <option v-for="day in daysInSelectedMonth" :key="day" :value="day">{{ day }}</option>
                    </select>
                  </vs-col>
                </vs-row>
                </div>
              </div>

              <div v-else-if="event.calendarType === 'hindu'">
                <div v-if="event.recurringInterval === 'monthly'">
                  <vs-row>
                    <vs-col vs-lg="12" vs-xs="12">
                      <label class="label">Tithi</label>
                      <select v-model="event.tithi" class="custom-select">
                        <option value disabled>Choose Tithi</option>
                        <option
                          v-for="(tithi, index) in translatedTithis"
                          :key="index"
                          :value="tithi"
                        >{{ tithi }}</option>
                      </select>
                    </vs-col>
                  </vs-row>
                </div>

                <div v-else-if="event.recurringInterval === 'yearly'">
                  <vs-row v-if="translatedTithis.length && translatedSuryanakshatras.length">
                    <vs-col vs-lg="6" vs-xs="6">
                      <label class="label">Tithi</label>
                      <select v-model="event.tithi" class="custom-select">
                        <option value disabled>Choose Tithi</option>
                        <option
                          v-for="(tithi, index) in translatedTithis"
                          :key="index"
                          :value="tithi"
                        >{{ tithi }}</option>
                      </select>
                    </vs-col>

                    <vs-col vs-lg="6" vs-xs="6">
                      <label class="label">Suryanakshatra</label>
                      <select v-model="event.suryanakshatra" class="custom-select">
                        <option value disabled>Choose Suryanakshatra</option>
                        <option
                          v-for="(suryanakshatra, index) in translatedSuryanakshatras"
                          :key="index"
                          :value="suryanakshatra"
                        >{{ suryanakshatra }}</option>
                      </select>
                    </vs-col>
                  </vs-row>
                </div>
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mt-4 p-bottom">
              <vs-checkbox v-model="event.feature">Feature Event</vs-checkbox>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mt-4 p-bottom" v-if="event.feature">
              <vs-col vs-lg="3" vs-xs="3" class="mt-4 p-bottom">
                <vs-checkbox v-model="event.alltime">All time</vs-checkbox>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="3" class="mt-4 p-bottom">
                <vs-checkbox v-model="event.district">District</vs-checkbox>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="3" class="mt-4 p-bottom">
                <vs-checkbox v-model="event.taluk">Taluk</vs-checkbox>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="3" class="mt-4 p-bottom">
                <vs-checkbox v-model="event.town">Town</vs-checkbox>
              </vs-col>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>
                Longitude
                <sub class="sub-text">*</sub>
              </label>
              <vs-input type="number" v-model="event.location.coordinates[0]" />
              <label>
                Latitude
                <sub class="sub-text">*</sub>
              </label>
              <vs-input type="number" v-model="event.location.coordinates[1]" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>
                Pincode
                <sub class="sub-text">*</sub>
              </label>
              <vs-input type="text" v-model="event.pincode" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="text" label="Phone Number" v-model="event.phone" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="text" label="Duration" v-model="event.duration" />
            </vs-col>
            <vs-col
              vs-lg="12"
              vs-xs="12"
            >Event created date : {{ new Date(event.createdAt).toLocaleString() }}</vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="mt-4 p-bottom">
              <vs-checkbox v-model="event.isPrivate">Is Private</vs-checkbox>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="mt-4 p-bottom">
              <vs-checkbox v-model="event.status">Status</vs-checkbox>
              <br />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                <label>
                  Event Start Date
                  <sub class="sub-text">*</sub>
                </label>
                <br />
                <datepicker
                  placeholder="Start Date"
                  v-model="event.startDate"
                  id="start_date"
                  format="yyyy-MM-dd"
                  input-class="form-group"
                  :open-date="new Date()"
                  @selected="dateSelected($event)"
                ></datepicker>
              </vs-col>
              <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                <label>
                  Event End Date
                  <sub class="sub-text">*</sub>
                </label>
                <br />
                <datepicker
                  placeholder="End Date"
                  v-model="event.endDate"
                  format="yyyy-MM-dd"
                  input-class="form-group"
                  :open-date="new Date()"
                ></datepicker>
              </vs-col>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                  <label>
                    Event Start Time
                    <sub class="sub-text">*</sub>
                  </label>
                  <br />
                  <vue-timepicker v-model="event.startTime"></vue-timepicker>
                </vs-col>
                <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                  <label>
                    Event End Time
                    <sub class="sub-text">*</sub>
                  </label>
                  <br />
                  <vue-timepicker v-model="event.endTime"></vue-timepicker>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <sub class="sub-text">Enter mobile numbers with comma separated</sub>
              <vs-textarea type="text" label="Enter Mobile Number" v-model="event.mobiles" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <sub class="sub-text">Enter email ids with comma separated</sub>
              <vs-textarea type="text" label="Enter Email Ids" v-model="event.emails" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <sub class="sub-text">Select application users to invite</sub>
              <multiselect
                v-model="event.users"
                placeholder="Select Users"
                label="firstName"
                track-by="_id"
                :options="userFollowers"
                :multiple="true"
              ></multiselect>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-button @click="btnAddEvent">Save</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- Code -->
        <vs-popup :title="isNew ? 'Add New User' : 'Edit User'" :active.sync="defaultalert">
          <vs-row>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-select
                :color="colorx"
                label="Language"
                v-model="user.language"
                icon="arrow_downward"
              >
                <vs-select-item value text="Choose Language" disabled />
                <vs-select-item
                  :value="item.culture"
                  :text="item.culture"
                  v-for="(item, index) in languages"
                  :key="index"
                />
              </vs-select>
              <br />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="text" label="User Email" v-model="user.userEmail" />

              <!-- <label v-if="!isNew" label="Language"
                >User Email : {{ user.userEmail }}</label
              >-->
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="text" label="Username" v-model="user.userName" />
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-input type="text" label="First Name" v-model="user.firstName" />
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-input type="text" label="Last Name" v-model="user.lastName" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="text" label="City" v-model="user.city" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="text" label="Country" v-model="user.country" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="text" label="Image" v-model="user.imageURL" />
            </vs-col>

            <vs-col vs-lg="12" vs-xs="12">
              <vs-input
                type="text"
                label="Longitude"
                v-if="user.location || isNew"
                v-model="user.location.coordinates[0]"
              />
              <vs-input
                type="text"
                label="Latitude"
                v-if="user.location || isNew"
                v-model="user.location.coordinates[1]"
              />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="text" label="FacebookId" v-model="user.facebookId" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="text" label="Mobile Number" v-model="user.userMob" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              Joining Date
              <datepicker
                placeholder="Joining Date"
                v-model="user.joinDate"
                id="start_date"
                format="yyyy-MM-dd"
                input-class="form-group"
                :open-date="new Date()"
                @selected="dateSelected($event)"
              ></datepicker>
              <vs-col vs-lg="12" vs-xs="12" class="mt-4 p-bottom">
                <vs-checkbox v-model="user.vipUser">is VIP User</vs-checkbox>
              </vs-col>
              <vs-col vs-lg="12" vs-xs="12" class="mt-4 p-bottom">
                <vs-checkbox v-model="user.isBanned">isBanned</vs-checkbox>
              </vs-col>
              <vs-col vs-lg="12" vs-xs="12" class="mt-4 p-bottom">
                <vs-checkbox v-model="user.isVerified">isVerified</vs-checkbox>
              </vs-col>
              <vs-col vs-lg="12" vs-xs="12" class="mt-4 p-bottom">
                <vs-checkbox v-model="user.isPrivateProfile">isPrivateProfile</vs-checkbox>
              </vs-col>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-button @click="btnAddUser">Save</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- Code -->
        <vs-popup class="holamundo" title="Delete User" :active.sync="deleteUserPopup">
          <p>Are you sure you want to delete this user?</p>
          <div>
            <vs-button class="mr15" @click="deleteUser">Delete User</vs-button>
            <vs-button @click="deleteUserPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>
        <vs-popup class="holamundo" title="Delete Event" :active.sync="deleteEventPopup">
          <p>Are you sure you want to delete this Event?</p>
          <div>
            <vs-button class="mr15" @click="deleteEvent">Delete Event</vs-button>
            <vs-button @click="deleteEventPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>
        <vs-popup
          class="holamundo user-info"
          title="View User"
          :active.sync="viewUserPopup"
          fullscreen
        >
          <vs-row>
            <vs-col vs-lg="6" vs-xs="6">
              User Information
              <div class="mt-4">
                <img
                  v-if="
                    itemToView.imageURL == '' || itemToView.imageURL == null
                  "
                  src="../../../assets/images/No-image.png"
                  height="50px"
                  width="75px"
                />
                <img v-else :src="itemToView.imageURL" height="50px" width="75px" />
                <br />
                <label>{{ itemToView.userName }}</label>
                <br />
                <label>{{ itemToView.firstName }} {{ itemToView.lastName }}</label>
                <br />
                <!-- <label>Last Name : {{ itemToView.lastName }}</label> -->
                <!-- <label>Image : {{ itemToView.imageURL }}</label> -->
                <!-- <label>Longitude : {{ itemToView.location.coordinates[0] }}</label>
                <label>Latitude : {{ itemToView.location.coordinates[1] }}</label>-->
                <label>FacebookId : {{ itemToView.facebookId }}</label>
                <br />
                <label>Mobile Number : {{ itemToView.userMob }}</label>
                <br />
                <label>Email : {{ itemToView.userEmail }}</label>
                <br />
              </div>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6">
              User Address
              <div class="mt-4">
                <label>City : {{ itemToView.city }}</label>
                <br />
                <label>Country : {{ itemToView.country }}</label>
                <br />
                <!-- <label>Longitude : {{ itemToView.location.coordinates[0] }}</label>
                <label>Latitude : {{ itemToView.location.coordinates[1] }}</label>-->
                <label>
                  Birth Date :{{
                  new Date(itemToView.birthday).toLocaleString()
                  }}
                </label>
                <br />
                <label>isBanned : {{ itemToView.isBanned }}</label>
                <br />
                <label>isVerified : {{ itemToView.isVerified }}</label>
                <br />
                <label>isPrivateProfile : {{ itemToView.isPrivateProfile }}</label>
                <br />
                <label>VIP User : {{ itemToView.vipUser }}</label>
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-select
              @change="findEvent($event)"
              v-model="search.findEvent"
              class="d-flex m-auto pb-4"
            >
              <vs-select-item value="created" text="Created" />
              <vs-select-item value="invited" text="Invited" />
              <vs-select-item value="attending" text="Attending" />
              <vs-select-item value="not attending" text="Not Attending" />
              <vs-select-item value="may be attending" text="May be attending" />
            </vs-select>
            <vs-button
              class="ml-auto mt-3 mb-3"
              type="filled"
              icon="add_circle"
              size="small"
              @click="addNewEvent"
            >Add New Event</vs-button>
          </vs-row>
          <table class="table">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Image</th>
              <th scope="col">Created Date</th>
              <th scope="col">title</th>
              <th scope="col">description</th>
              <!-- <th scope="col">Username</th> -->
              <th scope="col">Approval Status</th>
              <!-- <th scope="col">Language</th> -->
              <!-- <th scope="col">Mobile Number</th> -->
              <th scope="col"></th>
            </tr>
            <tr v-for="(item, index) in events" :key="item.name">
              <td scope="col">{{ (currentPage - 1) * pageSize + index + 1 }}</td>
              <td scope="col">
                <img
                  v-if="item.imageURL == '' || item.imageURL == null"
                  src="../../../assets/images/No-image.png"
                  height="50px"
                  width="75px"
                />
                <img v-else :src="item.imageURL" height="50px" width="75px" />
              </td>
              <td scope="col">{{ new Date(item.createdAt).toLocaleString() }}</td>
              <th scope="col">{{ item.title }}</th>
              <th scope="col" class="word-break">{{ item.description }}</th>
              <!-- <td scope="col">{{ item.usersId.userName }}</td> -->
              <td scope="col">
                <!-- {{ item.eventStatus }} -->
                <vs-chip v-if="item.eventStatus == 'APPROVED'" color="success">APPROVED</vs-chip>
                <vs-chip v-else-if="item.eventStatus == 'REJECTED'" color="danger">REJECTED</vs-chip>
                <vs-chip v-else color="warning">PENDING</vs-chip>
              </td>
              <!-- <td scope="col">{{ item.language }}</td> -->
              <!-- <td scope="col">{{ item.phone }}</td> -->

              <td class="td" v-if="search.findEvent == 'created'">
                <vs-button
                  class="mr15"
                  size="small"
                  color="warning"
                  @click="editingEvent(item)"
                >Edit</vs-button>
                <vs-button
                  class="mr15"
                  size="small"
                  color="danger"
                  @click="
                    deleteEventPopup = true;
                    eventToDelete = item;
                  "
                >Delete</vs-button>
              </td>
            </tr>
          </table>

          <!-- <div>
            <vs-button class="mr15" @click="deleteUser">Delete User</vs-button>
            <vs-button @click="viewUserPopup = false">Cancel</vs-button>
          </div>-->
        </vs-popup>
        <vs-popup class="holamundo" title="Ban User" :active.sync="banUserPopup">
          <p>
            Are you sure you want to Ban {{ usertoBan.firstName }}
            {{ usertoBan.lastName }} ?
          </p>
          <div>
            <vs-button class="mr15" @click="btnUpdateUser(true)">Confirm</vs-button>
            <vs-button @click="banUserPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>

        <!-- Event Popup -->
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import api from "@/rest.js";
import Datepicker from "vuejs-datepicker";
import VueGoogleAutocomplete from "vue-google-autocomplete";

import { API } from "@/common/constants";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import Multiselect from "vue-multiselect";
import moment from 'moment'

// import router from "@/router.js";
export default {
  name: "Users",
  components: {
    // uploader,
    Datepicker,
    VueTimepicker,
    // DatePicker,
    VueGoogleAutocomplete,
    Multiselect
  },
  data: () => ({
    colorx: "#0D2144",
    admin: {
      type: "USER"
    },
    viewPopup: false,
    all: [],
    events: [],
    categories: [],
    addAdmin: false,
    searchValue: "",
    fileName: "",
    languages: [],
    translatedTithis: [],
    translatedSuryanakshatras: [],
    userFollowers: [],
    isNew: true,
    defaultalert: false,
    deleteUserPopup: false,
    viewUserPopup: false,
    banUserPopup: false,
    deleteEventPopup: false,
    eventModal: false,
    newEvent: false,
    pagination: {},
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,

    search: {
      sort: 1,
      // language: "EN",
      status: "0",
      language: "",
      isBanned: "",
      isVerified: "",
      vipUser: "",
      searchKey: "",
      findEvent: "created"
    },
    user: {
      userEmail: "",
      language: "",
      isBanned: "",
      isVerified: "",
      vipUser: "",
      loginType: "",
      userMob: "",
      userName: "",
      name: "",
      city: "",
      country: "",
      facebookId: "",
      imageURL: "",
      isPrivateProfile: "",
      categoryList: "",
      location: { type: "Point", coordinates: [] },
      joinDate: "",
      firstName: "",
      lastName: ""
    },
    event: {
      email: "",
      language: "",
      title: "",
      description: "",
      phone: "",
      name: "",
      city: "",
      talukName: "",
      districtName: "",
      country: "",
      imageURL: "",
      categoryId: "",
      location: { type: "Point", coordinates: [] },
      startTime: "",
      endTime: "",
      usersId: {},
      address: "",
      address2: "",
      attachments: [],
      mobiles: [],
      emails: [],
      users: [],
      isRecurring: false,
      calendarType: "",
      recurringInterval: "",
      tithi: "",
      suryanakshatra: "",
      month: "",
      day: "",
      feature: false,
      alltime: false,
      district: false,
      taluk: false,
      town: false
    },
    gregorianMonths: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],

    itemToDelete: "",
    itemToView: "",
    usertoBan: "",
    eventToDelete: "",
    token:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjoiY2FsZW5kYXJhZG1pbiIsImlhdCI6MTYxMDE4MzU4Nn0.2Atr6Dtz47BauSGsbzNF5M-V8u-0nOgDi5UDeDpvtoE"
  }),
  computed: {
    daysInSelectedMonth() {
      if (!this.event.month) {
        return [];
      }
     

      const monthIndex = this.gregorianMonths.indexOf(this.event.month);
      const year = new Date().getFullYear(); 

      return Array.from({ length: moment(`${year}-${monthIndex + 1}`, 'YYYY-MM').daysInMonth() }, (_, i) => i + 1);
    },
    days() {
      return Array.from({ length: 31 }, (_, i) => i + 1);
    }
  },
  methods: {
    addNewEvent() {
      this.$data.eventModal = true;
      this.$data.viewUserPopup = false;
      this.$data.newEvent = true;
      this.$data.displayImage = "";
      this.$data.event = {
        email: "",
        language: "",
        title: "",
        description: "",
        phone: "",
        name: "",
        city: "",
        talukName: "",
        districtName: "",
        country: "",
        imageURL: "",
        categoryId: "",
        location: { type: "Point", coordinates: [] },
        startTime: "",
        endTime: "",
        usersId: {},
        attachments: [],
        address: "",
        address2: "",
        mobiles: [],
        emails: [],
        users: [],
        feature: false,
        alltime: false,
        district: false,
        taluk: false,
        town: false
      };
      if (document.querySelector(".clear-btn")) {
        document.querySelector(".clear-btn").click();
        setTimeout(() => {
          document.querySelector(".clear-btn").click();
        }, 500);
      }
    },
    getAddressData(data) {
      if (document.getElementById("map")) {
        this.$data.event.address = document.getElementById("map").value;
      }
      // this.$data.event.address = data.street_number
      //   ? data.street_number
      //   : data.route;
      if (data.longitude && data.latitude) {
        this.$data.event.location.coordinates = [data.longitude, data.latitude];
        this.$data.event.pincode = data.postal_code ? data.postal_code : "";
        this.$data.event.city = data.locality
          ? data.locality
          : data.administrative_area_level_2;
        this.$data.event.state = data.administrative_area_level_1;
      }
    },
    btnAddEvent() {
      var usersIds = [];
      if (
        !this.$data.event.endDate ||
        !this.$data.event.startDate ||
        !this.$data.event.title ||
        !this.$data.event.description ||
        !this.$data.event.address ||
        !this.$data.event.endTime ||
        !this.$data.event.startTime ||
        !this.$data.event.categoryId ||
        // !this.$data.event.imageURL||
        !this.$data.event.talukName ||
        !this.$data.event.districtName
      ) {
        this.$vs.notify({
          text: "Please enter all the details",
          color: "danger",
          position: "top-right"
        });
        return;
      }
      if (
        this.$data.event.mobiles &&
        this.$data.event.mobiles.length > 0 &&
        typeof this.$data.event.mobiles == "string"
      )
        this.$data.event.mobiles = this.$data.event.mobiles.split(",");
        if (this.$data.event.emails && typeof this.$data.event.emails === "string") {
      this.$data.event.emails = this.$data.event.emails.split(",");
    }
      if (this.$data.event.users && this.$data.event.users.length > 0) {
        for (var i = 0; i < this.$data.event.users.length; i++) {
          usersIds.push(this.$data.event.users[i]._id);
        }
        this.$data.event.users = usersIds;
      }
      this.$data.event["usersId"] = this.$data.itemToView._id;
      this.$data.event["language"] = this.$data.itemToView.language;

      let date = new Date(this.$data.event.startDate);
      let eDate = new Date(this.$data.event.endDate);
      this.$data.event.location.coordinates[0] = parseFloat(
        this.$data.event.location.coordinates[0]
      );
      this.$data.event.location.coordinates[1] = parseFloat(
        this.$data.event.location.coordinates[1]
      );

      if (this.$data.event.startDate) {
        this.$data.event.startDate =
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1) +
          "-" +
          date.getDate();
      }

      if (this.$data.event.endDate) {
        this.$data.event.endDate =
          eDate.getFullYear() +
          "-" +
          this.padTo2Digits(eDate.getMonth() + 1) +
          "-" +
          this.padTo2Digits(eDate.getDate());
      }
      if (!this.$data.newEvent) {
        // if (this.$data.user.userEmail == "") {
        //   this.$vs.notify({
        //     text: "User Email Require",
        //     color: "warning",
        //     position: "top-right",
        //   });
        //   return;
        // }
        if (typeof this.$data.event.startTime == "object") {
          this.$data.event.startTime =
            this.$data.event.startTime.hh + ":" + this.$data.event.startTime.mm;
        }
        if (typeof this.$data.event.endTime == "object") {
          this.$data.event.endTime =
            this.$data.event.endTime.hh + ":" + this.$data.event.endTime.mm;
        }
        this.btnUpdateEvent();
      } else {
        let data = this.$data.event;

        let headers = {
          "Content-Type": "application/json;charset=utf-8"
        };
        if (JSON.parse(localStorage.user).token) {
          headers["token"] = this.$data.token;
        }
        if (!data.feature) {
          data.alltime = false;
          data.district = false;
          data.taluk = false;
          data.town = false;
        } else {
          if (!data.alltime && !data.district && !data.taluk && !data.town) {
            this.$vs.notify({
              text: "Please select feature type",
              color: "danger",
              position: "top-right"
            });
            return;
          }
        }
        this.$vs.loading();
        api
          .post(API.GET_EVENT, data, { headers })
          .then(r => {
            this.$vs.loading.close();
            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right"
            });
            this.$data.newEvent = true;

            this.$data.eventModal = false;
            this.$data.viewUserPopup = true;
            (this.$data.event = {
              email: "",
              language: "",
              title: "",
              description: "",
              phone: "",
              name: "",
              city: "",
              talukName: "",
              districtName: "",
              country: "",
              imageURL: "",
              categoryId: "",
              location: { type: "Point", coordinates: [] },
              startTime: "",
              endTime: "",
              usersId: {},
              eventStatus: "",
              attachments: [],
              feature: false,
              alltime: false,
              district: false,
              taluk: false,
              town: false
            }),
              this.fetchAllEvents();
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      }
    },
    deleteImage() {
      this.$data.fileName = "";
      this.$data.event.imageURL = "";
    },
    deleteattachmentImage(item) {
      if (item > -1) {
        this.$data.event.attachments.splice(item, 1);
      }
    },
    uploadImage(data, attachments = false) {
      if (!attachments) {
        const imageType = ["image/jpeg", "image/jpg", "image/webp"];
        var isValid = false;
        isValid = imageType.indexOf(data.target.files[0].type) > -1;
        if (!isValid) {
          this.$vs.notify({
            title: "Uploading Error",
            text:
              "Only JPEG, JPG, WEBP files are allowed. Please upload a valid file",
            color: "danger",
            position: "top-right"
          });
          return;
        }
      }

      let formdata = new FormData();
      this.$data.fileName = data.target.files[0].name;
      formdata.append("file", data.target.files[0]);
      this.$vs.loading();
      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          console.log(response);
          console.log(attachments);
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right"
            });
          } else {
            this.$vs.loading.close();

            if (!attachments) {
              this.$data.event.imageURL = response.data.files[0].url;
            } else {
              console.log(response.data.files[0]);
              this.$data.event.attachments.push({
                filetype: response.data.files[0].fileType,
                fileurl: response.data.files[0].url
              });
              console.log(this.$data.event);
            }

            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right"
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right"
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => {});
      this.$vs.loading.close();
    },
    btnUpdateEvent() {
      var usersIds = [];
      if (
        !this.$data.event.endDate ||
        !this.$data.event.startDate ||
        !this.$data.event.title ||
        !this.$data.event.description ||
        !this.$data.event.address ||
        !this.$data.event.endTime ||
        !this.$data.event.startTime ||
        !this.$data.event.categoryId ||
        //!this.$data.event.imageURL||
        !this.$data.event.talukName ||
        !this.$data.event.districtName
      ) {
        this.$vs.notify({
          text: "Please enter all the details",
          color: "danger",
          position: "top-right"
        });
        return;
      }
      if (
        this.$data.event.mobiles &&
        this.$data.event.mobiles.length > 0 &&
        typeof this.$data.event.mobiles == "string"
      )
        this.$data.event.mobiles = this.$data.event.mobiles.split(",");
      if (
        this.$data.event.emails &&
        this.$data.event.emails.length > 0 &&
        typeof this.$data.event.emails == "string"
      )
        this.$data.event.emails = this.$data.event.emails.split(",");
      if (this.$data.event.users && this.$data.event.users.length > 0) {
        for (var i = 0; i < this.$data.event.users.length; i++) {
          usersIds.push(this.$data.event.users[i]._id);
        }
        this.$data.event.users = usersIds;
      }

      let data = this.$data.event;
      this.$data.event.location.coordinates[0] = parseFloat(
        this.$data.event.location.coordinates[0]
      );
      this.$data.event.location.coordinates[1] = parseFloat(
        this.$data.event.location.coordinates[1]
      );
      if (data.startDate) {
        let date = new Date(data.startDate);
        data.startDate =
          date.getFullYear() +
          "-" +
          this.padTo2Digits(date.getMonth() + 1) +
          "-" +
          this.padTo2Digits(date.getDate());
      }

      if (data.endDate) {
        let date = new Date(data.endDate);
        data.endDate =
          date.getFullYear() +
          "-" +
          this.padTo2Digits(date.getMonth() + 1) +
          "-" +
          this.padTo2Digits(date.getDate());
      }

      let id = this.$data.event._id;
      let headers = {
        "Content-Type": "application/json;charset=utf-8"
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      if (!data.feature) {
        data.alltime = false;
        data.district = false;
        data.taluk = false;
        data.town = false;
      } else {
        if (!data.alltime && !data.district && !data.taluk && !data.town) {
          this.$vs.notify({
            text: "Please select feature type",
            color: "danger",
            position: "top-right"
          });
          return;
        }
      }
      this.$vs.loading();
      api
        .put(API.GET_EVENT, data, { headers, params: { id: id } })
        .then(r => {
          this.$vs.loading.close();
          if (r.status == 200) {
            this.$vs.notify({
              text: "Updated Successfully",
              color: "success",
              position: "top-right"
            });
            this.$data.newEvent = true;

            this.$data.eventModal = false;
            this.$data.viewUserPopup = true;
            (this.$data.event = {
              email: "",
              language: "",
              title: "",
              description: "",
              phone: "",
              name: "",
              city: "",
              talukName: "",
              districtName: "",
              country: "",
              imageURL: "",
              categoryId: "",
              location: { type: "Point", coordinates: [] },
              startTime: "",
              endTime: "",
              usersId: {},
              eventStatus: "",
              attachments: [],
              mobiles: [],
              emails: [],
              users: [],
              feature: false,
              alltime: false,
              district: false,
              taluk: false,
              town: false
            }),
              this.fetchAllEvents();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right"
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    fetchAllLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then(r => {
          this.$vs.loading.close();
          this.$data.languages = r.data;
        })
        .catch(() => {});
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },
    fileter(event, param, flag = true) {
      this.$data.search[param] = event;
      this.$data.currentPage = 1;
      if (flag) {
        this.fetchAllUsers(this.$data.currentPage);
      }
    },
    fetchAllUsers(page) {
      this.$vs.loading();
      let headers = {
        "Content-Type": "application/json;charset=utf-8"
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      api
        .get(API.GET_USERS, {
          headers,
          params: {
            page: page,
            pageSize: this.$data.pageSize,
            sort: this.$data.search.sort,
            language: this.$data.search.language,
            isBanned: this.$data.search.isBanned,
            isVerified: this.$data.search.isVerified,
            searchKey: this.$data.search.searchKey,
            searchValue: this.$data.searchValue
          }
          // params: {
          //   language: this.$data.search.language,
          //   pageSize: this.$data.pageSize,
          //   pageNumber: page,
          // },
        })
        .then(r => {
          if (!r.data.data.data.length) {
            this.$data.all = r.data.data.data;
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Data Not Found",
              text: "No Record Found",
              color: "danger",
              position: "top-right"
            });
          } else {
            this.$vs.loading.close();
            this.$data.all = r.data.data.data;
            this.$data.pagination = r.data.data.meta.pagination;
            this.$data.totalPages = r.data.data.meta.pagination.total_pages;
          }
        })
        .catch(() => {});
    },
    addingNewItem() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.displayImage = "";
      this.$data.user = {
        userEmail: "",
        language: "",
        isBanned: "",
        vipUser: "",
        isVerified: "",
        loginType: "",
        userMob: "",
        userName: "",
        name: "",
        city: "",
        country: "",
        facebookId: "",
        imageURL: "",
        isPrivateProfile: "",
        categoryList: "",
        firstName: "",
        lastName: "",
        location: { type: "Point", coordinates: [] },
        joinDate: ""
      };
    },
    btnAddUser() {
      if (!this.$data.isNew) {
        if (this.$data.user.userEmail == "") {
          this.$vs.notify({
            text: "User Email Require",
            color: "warning",
            position: "top-right"
          });
          return;
        }
        if (this.$data.user.language == "") {
          this.$vs.notify({
            text: "Language Require",
            color: "warning",
            position: "top-right"
          });
          return;
        }
        this.btnUpdateUser();
      } else {
        let data = this.$data.user;
        let fieldName = "";
        if (data.userEmail == "") {
          fieldName = "User Email";
        }
        if (data.language == "") {
          fieldName = "Language";
        }
        if (data.userEmail == "" || data.language == "") {
          this.$vs.notify({
            text: fieldName + " Require",
            color: "warning",
            position: "top-right"
          });
          return;
        }
        this.$vs.loading();
        let headers = {
          "Content-Type": "application/json;charset=utf-8"
        };
        if (JSON.parse(localStorage.user).token) {
          headers["token"] = this.$data.token;
        }
        api
          .post(API.ADD_USER, data, { headers })
          .then(r => {
            this.$vs.loading.close();
            if (r.data.status) {
              this.$vs.notify({
                text: "Saved Successfully",
                color: "success",
                position: "top-right"
              });
              this.$data.isNew = true;
              this.$data.itemToUpdate = "";
              this.$data.defaultalert = false;
              (this.$data.user = {
                userEmail: "",
                language: "",
                isBanned: "",
                isVerified: "",
                loginType: "",
                userMob: "",
                userName: "",
                vipUser: "",
                name: "",
                city: "",
                country: "",
                facebookId: "",
                imageURL: "",
                isPrivateProfile: "",
                categoryList: "",
                location: { type: "Point", coordinates: [] },
                joinDate: "",
                firstName: "",
                lastName: ""
              }),
                this.fetchAllUsers(this.$data.currentPage);
            } else {
              this.$vs.notify({
                title: "Error",
                text: r.data.error,
                color: "danger",
                position: "top-right"
              });
            }
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      }
    },
    async fetchHinduCalendar(language) {
      try {
        const response = await api.get(
          `${API.FETCH_HINDU_CALENDAR}?data_language=${language}`
        );

        this.translatedTithis = response.data.tithis;
        this.translatedSuryanakshatras = response.data.suryaNakshatras;

        console.log("Fetched Tithis:", this.translatedTithis);
        console.log("Fetched Suryanakshatras:", this.translatedSuryanakshatras);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    editingItem(i) {
      this.$data.user = Object.assign({}, i);
      this.$data.defaultalert = true;
      this.$data.isNew = false;
    },
    editingEvent(i) {
      // let eDate = new Date(i.endDate);
      // i.endDate = new Date(
      //   eDate.getFullYear() +
      //     "/" +
      //     (eDate.getMonth() + 1) +
      //     "/" +
      //     (eDate.getDate() - 1)
      // );
      this.$data.event = Object.assign({}, i);
      this.$data.event["imageURL"] = this.$data.event.imageURL
        ? this.$data.event.imageURL
        : "";
      if (i.categoryId && i.categoryId._id)
        this.$data.event["categoryId"] = i.categoryId._id;
      this.$data.eventModal = true;
      this.$data.viewUserPopup = false;
      this.$data.newEvent = false;
    },
    btnUpdateUser(ban = false) {
      this.$vs.loading();
      var data = ban ? { isBanned: true } : this.$data.user;
      let id = ban ? this.$data.usertoBan._id : this.$data.user._id;
      let headers = {
        "Content-Type": "application/json;charset=utf-8"
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      api
        .put(API.UPDATE_USER, data, { headers, params: { id: id } })
        .then(r => {
          this.$vs.loading.close();
          if (r.status == 200) {
            this.$vs.notify({
              text: "Updated Successfully",
              color: "success",
              position: "top-right"
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            this.$data.usertoBan = "";
            this.$data.banUserPopup = false;
            (this.$data.user = {
              userEmail: "",
              language: "",
              isBanned: "",
              isVerified: "",
              loginType: "",
              vipUser: "",
              userMob: "",
              userName: "",
              name: "",
              city: "",
              country: "",
              facebookId: "",
              imageURL: "",
              isPrivateProfile: "",
              categoryList: "",
              location: { type: "Point", coordinates: [] },
              joinDate: "",
              firstName: "",
              lastName: ""
            }),
              this.fetchAllUsers(this.$data.currentPage);
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right"
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    deleteUser() {
      let id = this.$data.itemToDelete._id;
      let headers = {
        "Content-Type": "application/json;charset=utf-8"
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      api
        .delete(API.DELETE_USER, { headers, params: { id: id } })
        .then(r => {
          if (r.status == 200) {
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right"
            });
          } else {
            this.$vs.notify({
              text: "Already Deleted",
              color: "danger",
              position: "top-right"
            });
          }
          this.$data.deleteUserPopup = false;
          this.fetchAllUsers(this.$data.currentPage);
        })
        .catch(() => {});
    },
    pageChange(event) {
      if (event == "previous") {
        if (this.$data.currentPage <= 1) {
          return;
        } else {
          this.$data.currentPage--;
          this.fetchAllUsers(this.$data.currentPage);
        }
      } else {
        if (this.$data.currentPage == this.$data.totalPages) {
          return;
        } else {
          this.$data.currentPage++;
          this.fetchAllUsers(this.$data.currentPage);
        }
      }
    },
    dateSelected(e) {
      this.$data.user.joinDate = e;
    },
    resetData() {
      this.$data.search = {
        sort: 1,
        // language: "EN",
        status: "0",
        language: "",
        isBanned: "",
        isVerified: "",
        searchKey: ""
      };
      this.$data.searchValue = "";
      this.fetchAllUsers();
    },
    fetchAllEvents() {
      this.$data.search.findEvent = "created";
      this.fetchAllCategory(this.$data.itemToView.language);
      this.$vs.loading();
      let headers = {
        "Content-Type": "application/json;charset=utf-8"
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      api
        .get(API.GET_EVENT, {
          headers,
          params: {
            searchKey: "usersId",
            searchValue: this.$data.itemToView._id,
            pageSize: 10000
          }
          // params: {
          //   language: this.$data.search.language,
          //   pageSize: this.$data.pageSize,
          //   pageNumber: page,
          // },
        })
        .then(r => {
          if (!r.data.data.data.length) {
            this.$data.events = r.data.data.data;
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
            this.$data.events = r.data.data.data;
          }
        })
        .catch(() => {});
    },
    findEvent(e) {
      if (e != "created") {
        this.$vs.loading();
        let headers = {
          "Content-Type": "application/json;charset=utf-8"
        };
        if (JSON.parse(localStorage.user).token) {
          headers["token"] = this.$data.token;
        }
        api
          .post(API.EVENT_PARTICIPANT + "/find", {
            usersId: this.$data.itemToView._id,
            status: e
          })
          .then(r => {
            if (!r.data.length) {
              this.$data.events = r.data;
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$data.events = r.data;
            }
          })
          .catch(() => {});
      } else {
        this.fetchAllEvents();
      }
    },
    deleteEvent() {
      let id = this.$data.eventToDelete._id;
      let headers = {
        "Content-Type": "application/json;charset=utf-8"
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      api
        .delete(API.GET_EVENT, { headers, params: { id: id } })
        .then(r => {
          if (r.status == 200) {
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right"
            });
          } else {
            this.$vs.notify({
              text: "Already Deleted",
              color: "danger",
              position: "top-right"
            });
          }
          this.$data.deleteEventPopup = false;
          this.fetchAllEvents();
        })
        .catch(() => {});
    },
    fetchAllCategory(language) {
      this.$vs.loading();
      api
        .get(API.GET_EVENT_CAT + `?&language=${language}&status=1`, {})
        .then(r => {
          this.$vs.loading.close();
          this.$data.categories = r.data;
        })
        .catch(() => {});
    },
    cloneEventModal() {
      this.$data.viewUserPopup = true;
    },
    invitedUsers() {
      this.$vs.loading();
      let headers = {
        "Content-Type": "application/json;charset=utf-8"
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      api
        .post(API.GET_USERS + "/invitefollowers", {
          userId: this.$data.itemToView._id
        })
        .then(r => {
          this.$data.userFollowers = r.data;
          // if (!r.data.length) {
          //   this.$data.events = r.data;

          // } else {
          //   this.$vs.loading.close();
          //   this.$data.events = r.data;
          // }
        })
        .catch(r => {
          console.log(r);
          this.$vs.loading.close();
        });
    },
    openDoc(url) {
      window.open(url, "_blank");
    }
  },
  watch: {
    // "event.calendarType": function(newVal) {
    //   if (newVal === "hindu") {
    //     this.fetchHinduCalendar();
    //   }
    // }
  },
  created() {
    this.fetchAllLanguages();
    this.fetchAllUsers(this.$data.currentPage);
  }
};
</script>

<style scoped>
.leftHead h4 {
  font-size: 14px;
  font-weight: 600;
}
.rightHead h5 {
  font-size: 14px;
  font-weight: 400;
}
.title {
  font-size: 18px;
  font-weight: 600;
}
.top {
  margin-top: 10px;
}
.searchBtn {
  margin-top: 25px;
  width: 50%;
}
.mr15 {
  margin-right: 10px;
}
.mr5 {
  margin-right: 5px;
}
.pg-margin {
  margin-left: 80%;
}
.pagination {
  display: inline-block;
}
.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
}
.cursor-pointer {
  cursor: pointer;
}
.pag-arrow {
  color: #44a8ff !important;
  font-size: 20px;
}
.pag-txt-arrow {
  font-size: 15px;
  margin-top: 5px;
}
.drop-width {
  width: 150px !important;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}
.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.modalOpenCss {
  z-index: 1 !important;
  padding-top: 30px;
}
.pac-target-input {
  width: 100% !important;
  padding: 5px !important;
}
.sub-text {
  color: red;
  font-size: 12px;
}
.pointer {
  cursor: pointer;
}
.custom-select {
  display: block;
  width: 100%;
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  appearance: none;
}

.custom-select:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.label {
  margin-top: 1rem;
}
</style>
